/**
 * @author FJJ
 * @version 1.0
 * @Time 2022.05.26
 *
 **/
import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 *
 **/
const httpServer = {
    /**
     * 获取
     * @param data
     */
    postHttpAction(url,data={}) {
        return request({
            url: url,
            method: "POST",
            data
        });
    },
};

export default httpServer;